import OptionPage from "../components/optionPageStructure";
import { checkMissingSelections } from "../utils/checkMissingSelections";
import { floorPlanLoader } from "../components/floorPlanLoader";

export default function FurnitureArrangement() {
  return (
    <OptionPage
      title="Kylpyhuoneen kalustejärjestys"
      parentCategory="Kylpyhuoneen kalustejärjestys"
      previousParentCategory="Lämmitys ja laitteet"
      currentStep="furniture-arrangement"
      nextRoute="/furniture"
      customLoader={floorPlanLoader}
      checkMissingSelections={checkMissingSelections}
      pageType="furniture-arrangement"
    />
  );
}
